module.exports = __webpack_public_path__ + "img/06.18a503e1.jpg";